import React, { useState } from 'react';
import styles from './index.module.scss';
import { Button, SvgIcon } from '@ui-elements';
import { PopupBlocker } from '~/pages/model-landing/store';
import { useIsMobile } from '~/common/hooks/use-is-mobile';

export const GenericPopup = React.memo((props: PopupBlocker) => {
  const {
    isPopupBlockerActive,
    allowUserToClosePopupBlocker,
    popupBlockerBackgroundImageDesktop,
    popupBlockerBackgroundImageMobile,
    popupBlockerTitle,
    popupBlockerContent,
    popupBlockerCTA,
    popupBlockerDisclaimer,
  } = props;
  const [isPopupActive, setPopupActive] = useState(
    isPopupBlockerActive || false
  );
  const { isMobileOrSmallTablet } = useIsMobile();

  return isPopupActive ? (
    <div className={styles.genericPopupContainer}>
      <div className={styles.genericPopupBlocker} />
      <div className={styles.genericPopupWrapper}>
        <div
          className={styles.genericPopupHeader}
          style={{
            background: `url(${
              isMobileOrSmallTablet()
                ? popupBlockerBackgroundImageMobile ??
                  popupBlockerBackgroundImageDesktop
                : popupBlockerBackgroundImageDesktop
            })`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            borderRadius: '4px 4px 0',
          }}
        >
          {allowUserToClosePopupBlocker ? (
            <div
              className={styles.closeButton}
              onClick={() => {
                setPopupActive(!isPopupActive);
              }}
            >
              <SvgIcon type="close" color="#dadadb" size="30px" />
            </div>
          ) : (
            <div className={styles.closeButtonDisabled} />
          )}
          <span className={styles.disclaimer}>{popupBlockerDisclaimer}</span>
        </div>
        <div className={styles.genericPopupContent}>
          <h2 className={styles.title}>{popupBlockerTitle}</h2>
          <p className={styles.body}>{popupBlockerContent}</p>
        </div>
        <div className={styles.genericPopupFooter}>
          {popupBlockerCTA?.url && (
            <Button
              className={styles.redirectButton}
              target={popupBlockerCTA?.target}
              href={popupBlockerCTA?.url}
            >
              {popupBlockerCTA?.name}
            </Button>
          )}
        </div>
      </div>
    </div>
  ) : null;
});

export default GenericPopup;
